export default __webpack_public_path__ + "static/media/MOBI-200.65c5b450.png";